import { render, staticRenderFns } from "./cmp.vue?vue&type=template&id=0f485d19&scoped=true&"
import script from "./cmp.vue?vue&type=script&lang=js&"
export * from "./cmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f485d19",
  null
  
)

export default component.exports